module.exports = __webpack_public_path__ + "static/media/shila_thumb_wide.e003405f.webp";